import { IconButton, Stack } from "@mui/material";
import React from "react";
import { EditOutlined } from "@mui/icons-material";
import SingleToken from "./single-token";
import { TokenizedRuleInfos } from "./commons";
interface SingleLineNoEditProps {
  handleEditRule: (index: number) => void;
  x: TokenizedRuleInfos;
  i: number;
}
const SingleLineNoEdit: React.FC<SingleLineNoEditProps> = ({ handleEditRule, x, i }) => {
  const { tokens } = x;
  return (
    <Stack spacing={2} direction={"row"} justifyContent={"space-between"}>
      <Stack
        sx={{ cursor: "pointer" }}
        onClick={() => {
          handleEditRule(i);
        }}
        alignItems={"center"}
        flexWrap={"wrap"}
        spacing={1.5}
        direction={"row"}
      >
        {tokens && tokens.map((t, n) => <SingleToken token={t} key={n} index={n} />)}
      </Stack>
      <IconButton onClick={(e) => handleEditRule(i)} size="small">
        <EditOutlined color="primary" />
      </IconButton>
    </Stack>
  );
};

export default SingleLineNoEdit;
